import * as React from "react";
import { useUserPreferences } from "../containers/UserPreferencesContainer";
import { useLanguageTesting } from "../stores/useLanguageTesting";
import { changeLanguage, SupportedLanguage } from "../i18n/config";

/**
 * Hook that syncs language from multiple sources with priority:
 * 1. Testing override (localStorage) - if language testing active
 * 2. User preference (database) - normal mode
 * 3. Default 'en' - fallback
 *
 * Call this once near the top of the app to ensure language is set on load.
 */
export const useLanguageSync = () => {
  const { selectedLanguage, isActive } = useLanguageTesting();        // Testing override
  const { preferences, loading } = useUserPreferences();              // Database preference

  React.useEffect(() => {
    // Priority 1: Testing override (when active)
    if (isActive && selectedLanguage) {
      changeLanguage(selectedLanguage);
      return;
    }

    // Priority 2: Database preference (normal mode)
    if (!loading && preferences?.language) {
      changeLanguage(preferences.language as SupportedLanguage);
      return;
    }

    // Priority 3: Default fallback (if no preferences loaded yet)
    // i18n stays at default 'en'
  }, [selectedLanguage, isActive, preferences?.language, loading]);
};
